import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../../analytics.const';

import type { GalleryEvent } from './types';

const { GALLERY } = ANALYTICS_CATEGORIES;

export const triggerGalleryImageViewedEvent = ({ kind }: GalleryEvent): void => {
	const eventPayload = getSnowplowEventPayload({
		category: GALLERY,
		customData: { label: kind },
		name: 'dlr_hero_gallery_image_viewed',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
